import { lazy } from "../Lazy";
import { Alt1MouseTracking } from "./Alt1MouseTracking";
import { Alt1MainHotkeyEvent } from "./Alt1MainHotkeyEvent";
import { Alt1ContextMenuDetection } from "./Alt1ContextMenuDetection";
import * as a1lib from "alt1";
import { Alt1TooltipManager } from "./Alt1TooltipManager";
import { Alt1ScreenCaptureService } from "./capture/Alt1ScreenCaptureService";
import { Alt1OverlayManager } from "./Alt1OverlayManager";
import { Alt1GLSession } from "./alt1gl/Alt1GLSession";
import { Log } from "../util/Log";
var log = Log.log;
export class Alt1 {
    constructor() {
        this.raw = globalThis.alt1;
        this._alt1gl_disabled = false;
        this.mouse_tracking = new Alt1MouseTracking();
        this.main_hotkey = new Alt1MainHotkeyEvent();
        this.context_menu = new Alt1ContextMenuDetection();
        this.tooltips = new Alt1TooltipManager();
        this.capturing = new Alt1ScreenCaptureService();
        this.overlays = new Alt1OverlayManager();
        this._opengl = this.featureGL() ? new Alt1GLSession(this) : undefined;
        if (this.featureGL()) {
            this.raw?.on("log", e => log().log(e.message, "Alt1"));
        }
    }
    static instance() {
        return this._instance.get();
    }
    disableGLApi() {
        this._alt1gl_disabled = true;
        this._opengl?.forceClose();
        this._opengl = undefined;
    }
    featureGL() {
        return !this._alt1gl_disabled && this.raw?.permissionGLApi != undefined;
    }
    opengl() {
        return this._opengl;
    }
    permissions() {
        return {
            installed: alt1.permissionInstalled,
            overlays: alt1.permissionOverlay,
            screen_capture: alt1.permissionPixel,
            gamestate: alt1.permissionGameState,
            gl_api: alt1?.permissionGLApi ?? false,
            settings: alt1?.permissionSettings ?? false,
        };
    }
}
Alt1._instance = lazy(() => new Alt1());
(function (Alt1) {
    let Permissions;
    (function (Permissions) {
        function toString(self) {
            return `Installer ${self.installed}, Overlays ${self.overlays}, Pixel ${self.screen_capture}, Gamestate ${self.gamestate}, Gl Api ${self.gl_api}, Settings ${self.settings}`;
        }
        Permissions.toString = toString;
    })(Permissions = Alt1.Permissions || (Alt1.Permissions = {}));
    function exists() {
        return a1lib.hasAlt1 && !!alt1.identifyAppUrl;
    }
    Alt1.exists = exists;
    function checkPermission(f) {
        if (!Alt1.exists())
            return false;
        return f(Alt1.instance().permissions());
    }
    Alt1.checkPermission = checkPermission;
    function clientSize() {
        return { x: alt1.rsWidth, y: alt1.rsHeight };
    }
    Alt1.clientSize = clientSize;
})(Alt1 || (Alt1 = {}));
